import { render, staticRenderFns } from "./data72.vue?vue&type=template&id=6f99b70e&scoped=true&"
import script from "./data72.vue?vue&type=script&lang=js&"
export * from "./data72.vue?vue&type=script&lang=js&"
import style1 from "./data72.vue?vue&type=style&index=1&id=6f99b70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99b70e",
  null
  
)

export default component.exports